module.exports = __webpack_public_path__ + "img/lab.988d3ca6.jpeg";